import MyOrdersModule from './MyOrdersModule'
export default MyOrdersModule
